export default () => {
  const vkSocialBtn = document.querySelector(`.social-vk`);
  const fbSocialBtn = document.querySelector(`.social-fb`);
  const twSocialBtn = document.querySelector(`.social-tw`);
  const telSocialBtn = document.querySelector(`.social-tel`);

  const vkSocialBtn1 = document.querySelector(`.social-vk1`);
  const fbSocialBtn1 = document.querySelector(`.social-fb1`);
  const twSocialBtn1 = document.querySelector(`.social-tw1`);
  const telSocialBtn1 = document.querySelector(`.social-tel1`);

  if (typeof Ya !== 'undefined') {
    const share = Ya.share2(`socials`, {
      content: {
        url: window.location.href,
        title: document.title,
        description: `Description`,
        image: `${window.location.origin}/img/i-logo-icon.svg`
      },
      theme: {
        services: `vkontakte,facebook,twitter,telegram`
      },
      hooks: {
        onready() {
          const vkYandexBtn = document.querySelector(`#socials .ya-share2__item_service_vkontakte .ya-share2__link`);
          const fbYandexBtn = document.querySelector(`#socials .ya-share2__item_service_facebook .ya-share2__link`);
          const twYandexBtn = document.querySelector(`#socials .ya-share2__item_service_twitter .ya-share2__link`);
          const telYandexBtn = document.querySelector(`#socials .ya-share2__item_service_telegram .ya-share2__link`);

          if (vkSocialBtn && vkYandexBtn) {
            vkSocialBtn.addEventListener(`click`, () => {
              vkYandexBtn.click();
            })
            if(vkSocialBtn1) {
              vkSocialBtn1.addEventListener(`click`, () => {
                vkYandexBtn.click();
              })
            }
          }

          if (fbSocialBtn && fbYandexBtn) {
            fbSocialBtn.addEventListener(`click`, () => {
              fbYandexBtn.click();
            })
            if(fbSocialBtn1) {
              fbSocialBtn1.addEventListener(`click`, () => {
                fbYandexBtn.click();
              })
            }
          }
          if (twSocialBtn && twYandexBtn) {
            twSocialBtn.addEventListener(`click`, () => {
              twYandexBtn.click();
            })
            if(twSocialBtn1) {
              twSocialBtn1.addEventListener(`click`, () => {
                twYandexBtn.click();
              })
            }
          }

          if (telSocialBtn && telYandexBtn) {
            telSocialBtn.addEventListener(`click`, () => {
              telYandexBtn.click();
            })
            if(telSocialBtn1) {
              telSocialBtn1.addEventListener(`click`, () => {
                telYandexBtn.click();
              })
            }
          }
        }
      }
    });
  }
}
